import { defineComponent, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import SettingsPageHeader from '@/components/settings-page-header/settings-page-header.vue';
import { iconPageMultibrand } from '@/models/constants';
import { useAvailableWhitelabelsConfigStore } from '@/store/multibrand/available-whitelabels-config-list.store';
import { useLimitExceptionsUploadStore } from '@/store/limit-exceptions-upload/limit-exceptions-upload.store';
import UploadLimitExceptionsDialog
  from '@/layouts/limit-exceptions-upload-page/upload-limit-exceptions-dialog/upload-limit-exceptions-dialog.vue';

export default defineComponent({
  name: 'LimitExceptionsUploadPage',
  components: {
    SettingsPageHeader,
    UploadLimitExceptionsDialog,
  },
  setup() {
    const availableWhitelabelsConfigStore = useAvailableWhitelabelsConfigStore();
    const { isMultibrandIconVisible } = storeToRefs(availableWhitelabelsConfigStore);
    const { getAvailableWhitelabelConfigList } = availableWhitelabelsConfigStore;

    const { setUploadModalOpen } = useLimitExceptionsUploadStore();

    onMounted((): void => {
      getAvailableWhitelabelConfigList();
    });

    return {
      isMultibrandIconVisible,
      iconPageMultibrand,
      setUploadModalOpen,
    };
  },
});
